import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

//import { db } from "@/fstore";
//import router from "@/router";
import { db } from "@/fstore";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    is_admin: false,
    group_list: []
  },
  mutations: {
    set_group_list: function(state, group_list) {
      console.log("set_group_list");
      state.is_admin = true;
      state.group_list = group_list;
    }
  },
  actions: {
    loadGroups: ({ commit, rootState }) => {
      console.log("loadGroups");
      db.collection("groups")
        .where("managers", "array-contains", rootState.user.uid)
        .onSnapshot(
          function(querySnapshot) {
            var group_list = [];
            querySnapshot.forEach(function(doc) {
              group_list.push(doc.data());
            });
            console.log(group_list);
            commit("set_group_list", group_list);
          },
          function() {
            // Silently eat admin query error.
            // console.log(error);
          }
        );
    },
    removeUserFromGroup: ({ dispatch }, update_obj) => {
      var email = update_obj.email;
      var id = update_obj.id;
      var update = {
        approved_email_addresses: firebase.firestore.FieldValue.arrayRemove(
          email
        )
      };
      update.updated_at = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("groups")
        .doc(id)
        .update(update)
        .then(() => {
          console.log("complete");
          dispatch("triggerGroupSyncUpdate", id);
        });
    },
    addUserToGroup: ({ dispatch }, update_obj) => {
      var email = update_obj.email;
      var id = update_obj.id;
      var update = {
        approved_email_addresses: firebase.firestore.FieldValue.arrayUnion(
          email
        )
      };
      update.updated_at = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("groups")
        .doc(id)
        .update(update)
        .then(() => {
          console.log("complete");
          dispatch("triggerGroupSyncUpdate", id);
        });
    },
    updateGroup: ({ dispatch }, update_obj) => {
      var id = update_obj.id;
      var update = {
        all_visible_plan_description: update_obj.all_visible_plan_description,
        user_visible_note: update_obj.user_visible_note,
        billing_email: update_obj.billing_email
      };
      update.updated_at = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("groups")
        .doc(id)
        .update(update)
        .then(() => {
          console.log("complete");
          dispatch("triggerGroupSyncUpdate", id);
        });
    },
    triggerGroupSyncUpdate: ({ rootState }, uid) => {
      console.log(rootState.user.id);
      axios
        .get(`https://subscriptions.soundslides.com/groups/${uid}/sync/`)
        .then(function(e) {
          console.log(e);
          console.log("triggerGroupSyncUpdate, success");
        });
    }
  }
};
